import { sortOptionsISelect } from "../helpers/sortISelect";
import { DocumentType } from "../model/enumerations/document-type.model";
import { ISelect } from "../model/iSelect";

export const documentTypeEnum = (): Array<ISelect> => {
  const documentType: Array<ISelect> = [
    {
      label: `DNI`,
      value: DocumentType.ID,
    },
    {
      label: `Pasaporte`,
      value: DocumentType.PASSPORT,
    },
  ];
  return sortOptionsISelect(documentType);
};
